module.exports = __webpack_public_path__ + "img/FAV_0056.386cae79.jpg";